import Box from "@mui/material/Box";
import { useState } from "react";
import { CPTextField } from "./CPTextField";
import { CPButton } from "./CPButton";
import { CPTitle } from "./CPTitle";

interface SingleTextFieldSubmitProps {
  title: string;
  boldTitle?: string;
  hint?: string;
  label: string;
  labelButton: string;
  value?: string;
  textType?: string;
  loading?: boolean;
  errorMessage?: string;
  onClick?: (text: string) => void;
  capitalizeFirstLetterOnly?: boolean;
  inputProps?: any;
}

export const SingleTextFieldSubmit = ({
  title,
  boldTitle = "",
  hint,
  label,
  labelButton,
  loading,
  value = "",
  textType = "text",
  errorMessage = "",
  onClick = () => {},
  ...props
}: SingleTextFieldSubmitProps) => {
  const [text, setText] = useState(value);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onClick(text);
  };

  return (
    <form noValidate onSubmit={handleSubmit} className="w-100">
      <CPTitle
        className="mb-4"
        title={title}
        boldTitle={boldTitle}
        hint={hint}
      />

      <Box className="mb-4">
        <CPTextField
          id={label}
          label={label}
          value={text}
          type={textType}
          errorMessage={errorMessage}
          onChange={(val) => setText(val)}
          capitalizeFirstLetterOnly={props.capitalizeFirstLetterOnly}
          inputProps={props.inputProps}
        />
      </Box>
      <Box>
        <CPButton
          label={labelButton}
          loading={loading}
        />
        
      </Box>
    </form>
  );
};
